import defaultErrorHandler from "actions/global/default-error-handler";
import { requestCommonFilters, requestCommonSearch } from "actions/common/requests";
import filterTypes from "data/filter-types";
import {
  WALLET_LOADING,
  WALLET_ERROR,

  WALLET_GET_LIST,
  WALLET_GET_FILTERS,
  WALLET_GET_SINGLE,
} from "actions/wallet/constants";

export const setLoading = (status) => ({
  type: WALLET_LOADING,
  payload: status
});

export const getWalletList = (page = 0, size = 20, sort = "id,asc", criteria = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("wallet", page, size, sort, criteria)
    .then(payload => {
      dispatch({
        type: WALLET_GET_LIST,
        payload
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, WALLET_ERROR));
    });
};

export const getWalletSingle = (userId) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("wallet", 0, 1, "id,asc", [{
    fieldName: "id",
    fieldValue: userId,
    searchOperation: filterTypes.EQUALS.value
  }])
    .then((response) => {
      dispatch({
        type: WALLET_GET_SINGLE,
        payload: response.content && response.content[0]
          ? response.content[0]
          : {}
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, WALLET_ERROR));
    });
};

export const getWalletFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters("wallet")
    .then((response) => {
      dispatch({
        type: WALLET_GET_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, WALLET_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/wallet/actions.js